import { useClientExpenseDocuments } from '../../hooks/usePortal';
import { DocumentPreviewPicker } from '../documents/DocumentPreviewPicker';

interface ClientExpenseDocumentsModalProps {
  eventId: string;
  expenseItemId: string;
  onClose: () => void;
}

/**
 * Read-only viewer for the files attached to one expense in the client portal.
 * Reads the event-scoped portal endpoint (never the producer expense routes)
 * and renders the shared picker, so a client can open invoices, quotes and
 * other attachments without any edit affordance.
 */
export function ClientExpenseDocumentsModal({
  eventId,
  expenseItemId,
  onClose,
}: ClientExpenseDocumentsModalProps) {
  const { data: docs = [], isLoading } = useClientExpenseDocuments(eventId, expenseItemId);

  return (
    <DocumentPreviewPicker
      documents={docs}
      isLoading={isLoading}
      onClose={onClose}
      emptyMessage="No documents attached"
    />
  );
}
